import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DateValidator {

  /**
   * Checks if the input string 'date' is a valid Date
   * @param date
   * @returns true or false
   */
  public static isValidDate(date: String) {
    if (date == null || date.trim().length === 0) return false;

    //Verifica se a data é válida: new Date pega próxima data se tentar criar com data inválida
    var dateArr = date.trim().split("/");
    let day = parseInt(dateArr[0]);
    let month = parseInt(dateArr[1]);
    let year = parseInt(dateArr[2]);
    if (isNaN(day) || isNaN(month) || isNaN(year)) return false;

    let dateObj = new Date(year, month-1, day);
    let result = (day == dateObj.getDate()) && (month == (dateObj.getMonth()+1)) && (year == dateObj.getFullYear());

    //Verifica formato (segunda validação)
    let result2 = moment(""+date.trim(), 'DD/MM/YYYY', true).isValid();

    return result && result2;
  }
}

